export default __webpack_public_path__ + "static/media/tschuess.985fd083.jpg";